





























import { Component, Vue } from 'vue-property-decorator';

import SectionData from '@/componentsV2/organisms/SectionData/SectionData.vue';
import BaseChart from '@/componentsV2/molecules/Chart/BaseChart.vue';

import PerformanceOverviewService from '@/api/PerformanceOverview';

import PerformanceUtils from '@/utils/PerformanceUtils';
import { applyPerformanceDataFilter } from '@/views/Performance/flag-helpers';

import { IPeriod } from '@/models/period';
import { IChartSerie, IInitiativeFilter } from '@/models/performance';
import {
  EInitiativesDictionary,
  InitiativeThemeDictionary
} from '@/models/initiatives';
import flagKeys from '@/constants/flagKeys';

@Component({
  components: {
    SectionData,
    BaseChart
  }
})
export default class PerformanceYourInitiatives extends Vue {
  performanceOverviewService = new PerformanceOverviewService();
  filters: IInitiativeFilter[] = [];
  options = PerformanceUtils.chartOptions();
  series: IChartSerie[] = [];
  loading = false;
  filterQueryParameters: string[] = [];
  period: IPeriod = PerformanceUtils.defaultPeriod();
  busine: IPeriod = PerformanceUtils.defaultPeriod();

  get queryParameters() {
    return {
      from: this.period.start,
      to: this.period.end,
      initiatives: this.filterQueryParameters
    };
  }

  get flags() {
    return this.$store.getters['flags/getFlags'] || [];
  }

  get businessReferralIsActivated() {
    return this.flags.includes(flagKeys.businessReferral);
  }

  get customerImportIsActivated() {
    return this.flags.includes(flagKeys.customerImport);
  }

  created() {
    this.getYourCampaigns();
  }

  get filterGATracking() {
    return {
      eventCategory: 'Your Campaigns Chart - Tag Filter',
      eventAction: 'click'
    };
  }

  get periodGATracking() {
    return {
      period: {
        eventCategory: 'Your Campaigns Chart - Period',
        eventAction: 'change'
      }
    };
  }

  async getYourCampaigns({ useFilters = true } = {}) {
    this.loading = true;

    const queryParameters = useFilters ? this.queryParameters : {};

    const response = await this.performanceOverviewService.getYourCampaigns(
      queryParameters
    );

    this.loading = false;

    if (response.status !== 200) return;

    const { datasets, labels, filters } = response.data;

    const filteredDatasetsByFeatureFlag = datasets
      .filter(
        applyPerformanceDataFilter(
          this.businessReferralIsActivated,
          'slug',
          flagKeys.referralProgram
        )
      )
      .filter(
        applyPerformanceDataFilter(
          this.customerImportIsActivated,
          'slug',
          flagKeys.customerImport
        )
      );

    const filteredDatasets = PerformanceUtils.filteredDataBySlug(
      filteredDatasetsByFeatureFlag,
      'slug'
    );

    if (filters && filters.initiatives && !!filters.initiatives.length) {
      this.filters = PerformanceUtils.getFiltersFiltered(filters.initiatives);
    }

    const colors = filteredDatasets.map(
      dataset =>
        InitiativeThemeDictionary[dataset.slug as EInitiativesDictionary].color
    );

    this.options = Object.assign({}, this.options, { colors });
    this.series = PerformanceUtils.normalizedChartSeries({
      labels,
      datasets: filteredDatasets
    });
  }

  handleFilterChange(filters: string[]) {
    this.filterQueryParameters = filters;
    this.getYourCampaigns();
  }

  handlePeriodChange(period: IPeriod) {
    this.period = PerformanceUtils.normalizedPeriod(period);
    this.getYourCampaigns();
  }
}
